import gql from 'graphql-tag';

export const QuickReloadGQLQuery = gql`
	query QuickReloadQuery($contentId: Long!, $since: Long!) {
		quickReload(pageId: $contentId, since: $since) {
			time
			editorForPage {
				displayName
				accountId
				profilePicture {
					path
				}
			}
			comments {
				comment {
					id
					author {
						displayName
						... on KnownUser {
							accountId
						}
						... on UnknownUser {
							accountId
						}
						... on User {
							accountId
						}
						profilePicture {
							path
						}
					}
					body(representation: ATLAS_DOC_FORMAT) {
						value
					}
					location {
						type
						... on InlineComment {
							inlineMarkerRef
						}
					}
					createdAtNonLocalized
					parentId
				}
			}
		}
	}
`;

export const QuickReloadPubSubQuery = gql`
	query PubSubUserQuery($accountId: String) {
		confluenceUsers(accountIds: [$accountId]) {
			nodes {
				displayName
				profilePicture {
					path
				}
			}
		}
	}
`;
